module.exports = __webpack_public_path__ + "static/SuburbanStore-5e4263459365646a63aa2a0b0a5c73a1.jpg";